
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 17","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 8.333L1.667 5v8L9 16.333zm0 0L16.333 5v8L9 16.333zM16.333 5L9 1.666 1.667 5","stroke":"currentColor","stroke-width":"1.5","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    